import { Navigate, Outlet } from 'react-router-dom';

export interface IProtectedRouteProps {
  isAllowed: boolean;
  redirectPath?: string;
  children?: React.ReactElement;
}

export const ProtectedRoute: React.FC<IProtectedRouteProps> = ({
  isAllowed,
  redirectPath = '/',
  children,
}) => {
  if (!isAllowed) {
    return <Navigate to={redirectPath} replace />;
  }

  return children || <Outlet />;
};
